import React from 'react'
import { styled } from '@mui/material'

export const ViewContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
})

